import { render, staticRenderFns } from "./DeleteUserFromGroupModal.vue?vue&type=template&id=7a8bcea8&"
import script from "./DeleteUserFromGroupModal.vue?vue&type=script&lang=js&"
export * from "./DeleteUserFromGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports